import React from 'react';
import MyNavbar from '../components/MyNavbar';

export default function PageNotFound() {
    return (
        <>
            <div className="container d-flex align-items-center justify-content-center vh-100">
                <div className="text-center">
                    <h1 className="display-1 fw-bold text-danger">404</h1>
                    <h2 className="mb-3">Page Not Found</h2>
                    <p className="text-muted mb-4">
                        Oops! The page you're looking for doesn't exist or has been moved.
                    </p>
                    <a href="/" className="btn btn-secondary btn-lg">
                        Go Back Home
                    </a>
                </div>
            </div>
        </>
    );
}
